'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImageFrame = require('./ImageFrame');

var _ImageFrame2 = _interopRequireDefault(_ImageFrame);

var _ImagePlaceholderFrame = require('./ImagePlaceholderFrame');

var _ImagePlaceholderFrame2 = _interopRequireDefault(_ImagePlaceholderFrame);

var _SelectImage = require('./SelectImage');

var _SelectImage2 = _interopRequireDefault(_SelectImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageSelectControl = function () {
  function ImageSelectControl(element, args) {
    var _this = this;

    _classCallCheck(this, ImageSelectControl);

    var div = document.createElement('div');
    var label = document.createElement('label');
    label.innerHTML = args.label;
    var popup = null;
    this.value = args.image;
    this.property = document.createElement('div');
    this.property.className = 'contact';
    this.property.onclick = function () {
      if (args.readonly) {
        return;
      }
      var popupElement = document.getElementById('popup');
      var viewportElement = document.getElementById('viewport');

      popup = new _SelectImage2.default(popupElement, {
        onok: function onok(image) {
          _this.setValue(image);
          viewportElement.classList.remove('invisible');
          popupElement.classList.add('invisible');
          popupElement.innerHTML = '';

          if (_this.onchange) {
            _this.onchange();
          }
        },
        oncancel: function oncancel() {
          viewportElement.classList.remove('invisible');
          popupElement.classList.add('invisible');
          popupElement.innerHTML = '';
        },
        image: _this.value
      });
      viewportElement.classList.add('invisible');
      popupElement.classList.remove('invisible');
    };

    this.image = undefined;
    this.placeholder = undefined;
    this.onchange = args.onchange;

    if (this.value) {
      this.image = new _ImageFrame2.default(this.property, {
        image: this.value
      });
    } else {
      this.placeholder = new _ImagePlaceholderFrame2.default(this.property, {
        title: '?'
      });
    }

    div.appendChild(label);
    div.appendChild(this.property);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    element.appendChild(fragment);
  }

  _createClass(ImageSelectControl, [{
    key: 'getValue',
    value: function getValue() {
      return this.value;
    }
  }, {
    key: 'setValue',
    value: function setValue(newImage) {
      this.value = newImage;

      if (!newImage) {
        if (this.placeholder) {
          this.placeholder.setTitle('?');
        } else {
          this.placeholder = new _ImagePlaceholderFrame2.default(null, { title: '?' });
          this.property.insertBefore(this.placeholder.getElement(), this.property.childNodes[0]);
        }

        if (this.image) {
          this.property.removeChild(this.image.getElement());
          this.image = undefined;
        }

        return;
      }

      if (this.image) {
        this.image.setImage(newImage);
      } else {
        this.image = new _ImageFrame2.default(null, { image: newImage });
        this.property.insertBefore(this.image.getElement(), this.property.childNodes[0]);
      }

      if (this.placeholder) {
        this.property.removeChild(this.placeholder.getElement());
        this.placeholder = undefined;
      }
    }
  }, {
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }]);

  return ImageSelectControl;
}();

exports.default = ImageSelectControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/ImageSelectControl.js
// module id = 37
// module chunks = 0